import React from 'react';
import { DateFormat } from 'stageclip-common';
import moment from 'moment-timezone';
import { ActionViewModel } from 'stageclip-common/build/view-models/action-view-model';

import { ActionLogDetailsModal } from 'components/actionLogDetailsModal/ActionLogDetailsModal';
import Button from 'components/buttons/button';
import { AppTable, AppTableColumn } from 'components/table/appTable';
import { ActionLogTableProps } from './ActionLogTable.types';

export const ActionLogTable = ({ data, openDetails, loading }: ActionLogTableProps) => {
  const columns: AppTableColumn[] = [
    {
      Header: 'Action',
      accessor: ({ action }: ActionViewModel) => action,
      id: 'action',
    },
    {
      Header: 'User',
      accessor: ({ user }: ActionViewModel) => (user ? `${user.firstName} ${user.lastName}` : 'auto'),
      id: 'user',
    },
    {
      Header: 'Date',
      accessor: ({ timestamp }: ActionViewModel) => moment(timestamp).format(DateFormat.DateTime),
      id: 'date',
    },
    {
      Cell: ({ value }: { value: ActionViewModel }) => {
        const { data: detailsData, action, timestamp } = value;

        return detailsData ? (
          <Button onClick={() => openDetails({ data: detailsData, action, timestamp })} text="Details" />
        ) : (
          '-'
        );
      },
      Header: 'Details',
      accessor: (action: ActionViewModel) => action,
      id: 'details',
    },
  ];

  return (
    <div>
      <AppTable
        columns={columns}
        data={data}
        tableName="actions-log"
        defaultSorted={[{ id: 'date', desc: true }]}
        loading={loading}
      />
      <ActionLogDetailsModal />
    </div>
  );
};
